import { render, staticRenderFns } from "./EnvioInformacion.vue?vue&type=template&id=5793dd53&"
import script from "./EnvioInformacion.vue?vue&type=script&lang=ts&"
export * from "./EnvioInformacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5793dd53', component.options)
    } else {
      api.reload('5793dd53', component.options)
    }
    module.hot.accept("./EnvioInformacion.vue?vue&type=template&id=5793dd53&", function () {
      api.rerender('5793dd53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/EnvioInformacion/EnvioInformacion.vue"
export default component.exports